module.exports = __webpack_public_path__ + "r-v3/img/mic_on.55898d3f.svg";